import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from 'antd';
import { autobind } from 'core-decorators';
import BaseComponent from 'components/BaseComponent';
import styledComp from 'components/StyledComp';
import DataTables from 'components-desktop/DataTables';

const propTypes = {
  title: PropTypes.string,
  efiles: PropTypes.array,
};

const defaultProps = {
  title: '',
  efiles: [],
};

@autobind
class TableEfiles extends BaseComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
  }

  createColumns() {
    return [{
      title: 'ID',
      dataIndex: 'id',
      sorter: (a, b) => a.id - b.id,
      defaultSortOrder: 'descend',
    }, {
      title: 'Patient',
      dataIndex: 'patientName',
      sorter: (a, b) => a.patientName?.localeCompare(b.patientName),
      render: (text, record) => (
        <styledComp.A
          width="wrap_content"
          height="wrap_content"
          href={`/patients/patient_profile?id=${record.patientId}`}
          target="_blank"
        >
          {text}
        </styledComp.A>
      ),
    }, {
      title: 'Caregiver',
      dataIndex: 'caregiverName',
      sorter: (a, b) => a.caregiverName?.localeCompare(b.caregiverName),
      render: (text, record) => (
        <styledComp.A
          width="wrap_content"
          height="wrap_content"
          href={`/caregivers/caregiver_profile?id=${record.caregiverId}#efiles`}
          target="_blank"
        >
          {text}
        </styledComp.A>
      ),
    }, {
      title: 'Time',
      dataIndex: 'timeUsString',
      sorter: (a, b) => a.time - b.time,
    }, {
      title: 'Type',
      dataIndex: 'type',
      sorter: (a, b) => a.type?.localeCompare(b.type),
    }, {
      title: 'File 1',
      dataIndex: 'file1Id',
      sorter: (a, b) => a.file1Id - b.file1Id,
      render: (text, record) => (
        <styledComp.A
          width="wrap_content"
          height="wrap_content"
          href={record.file1Url}
          target="_blank"
        >
          {text}
        </styledComp.A>
      ),
    }, {
      title: 'File 2',
      dataIndex: 'file2Id',
      sorter: (a, b) => a.file2Id - b.file2Id,
      render: (text, record) => (
        <styledComp.A
          width="wrap_content"
          height="wrap_content"
          href={record.file2Url}
          target="_blank"
        >
          {text}
        </styledComp.A>
      ),
    }, {
      title: 'File 3',
      dataIndex: 'file3Id',
      sorter: (a, b) => a.file3Id - b.file3Id,
      render: (text, record) => (
        <styledComp.A
          width="wrap_content"
          height="wrap_content"
          href={record.file3Url}
          target="_blank"
        >
          {text}
        </styledComp.A>
      ),
    }, {
      title: 'Brief Note',
      dataIndex: 'description',
      sorter: (a, b) => a.description?.localeCompare(b.description),
      render: (text, record) => (
        <Tooltip title={text}>
          <styledComp.Span
            width="wrap_content"
            height="wrap_content"
            maxWidth="250px"
            color="textPrimaryDark"
            fontSize="14px"
            ellipsis
            display="inline-block"
          >
            {text}
          </styledComp.Span>
        </Tooltip>
      ),
    }];
  }

  createDataSource(efiles) {
    const dataSource = [];
    efiles.forEach((efile, index) => {
      dataSource.push({
        key: efile.getId(),
        id: efile.getId(),
        patientId: efile.getLong('patientId'),
        patientName: efile.getString('patientName'),
        caregiverId: efile.getLong('caregiverId'),
        caregiverName: efile.getString('caregiverName'),
        time: efile.getLong('time'),
        timeUsString: efile.getString('timeUsString'),
        type: efile.getString('type'),
        file1Id: efile.getLong('file1Id'),
        file1Url: efile.getRemoteObject('file1')?.getString('originalUrl'),
        file2Id: efile.getLong('file2Id'),
        file2Url: efile.getRemoteObject('file2')?.getString('originalUrl'),
        file3Id: efile.getLong('file3Id'),
        file3Url: efile.getRemoteObject('file3')?.getString('originalUrl'),
        description: efile.getString('description'),
      });
    });
    return dataSource;
  }

  renderContent() {
    const { efiles, title, ...layoutProps } = this.props;

    return (
      <DataTables
        {...layoutProps}
        color="green_haze"
        fontSize="12px"
        size="small"
        title={title}
        icon="file"
        selectable={false}
        columns={this.createColumns()}
        dataSource={this.createDataSource(efiles)}
      />
    );
  }
}

// https://facebook.github.io/react/docs/typechecking-with-proptypes.html
TableEfiles.propTypes = propTypes;
TableEfiles.defaultProps = defaultProps;

export default TableEfiles;
